import React from 'react'
import { notification } from '../../common/svg'
import SecureImage from "../../components/BucketImage/Image";
const Notification = () => {
  return (
      <div className='flex items-center justify-center'>
        <div className='w-[8px] h-[8px] bg-[#FF0000] rounded-full absolute right-[23px] top-[20px]' />
      <button className='bg-[#444FBD] h-[28px] w-[28px] flex items-center justify-center rounded-full'>
           <SecureImage
            
            fileKey={notification}
            alt="header icon"
            width="20px"
      />
      </button>
    </div>
  )
}

export default Notification
